import { createContext, useContext, useState } from 'react';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState('fr');

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error('useLang must be used within LangProvider');
  }
  
  const { lang } = context;
  
  const t = (key) => {
    const translations = {
      fr: {
        login: 'Connexion',
        register: 'Inscription',
        logout: 'Déconnexion',
        save: 'Sauvegarder',
        cancel: 'Annuler',
        email: 'Email',
        password: 'Mot de passe',
        name: 'Nom complet',
        auditor: 'Auditeur',
        sponsor: 'Sponsor',
        'landing.badge': 'Plateforme d\'audit clinique',
        'landing.title': 'Planifiez vos audits cliniques avec précision',
        'landing.subtitle': 'La plateforme SaaS qui connecte auditeurs et sponsors',
        'landing.cta': 'Créer un compte gratuit',
        'auth.title': 'Bienvenue sur AuditPlan',
        'auth.role': 'Je suis un',
      },
      en: {
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
        save: 'Save',
        cancel: 'Cancel',
        email: 'Email',
        password: 'Password',
        name: 'Full name',
        auditor: 'Auditor',
        sponsor: 'Sponsor',
        'landing.badge': 'Clinical Audit Platform',
        'landing.title': 'Plan your clinical audits with precision',
        'landing.subtitle': 'The SaaS platform connecting auditors and sponsors',
        'landing.cta': 'Create free account',
        'auth.title': 'Welcome to AuditPlan',
        'auth.role': 'I am a',
      }
    };
    
    return translations[lang]?.[key] || key;
  };
  
  return { ...context, t };
}
